import { defaultSpacing } from '@rneui/base/dist/helpers';
export { defaultSpacing };
